<template>
  <div class="navbar_box">
    <headerNavPc v-if="nav_name == 'headerNavPc'" class="headerNavPc"></headerNavPc>
    <headerNavMove v-else class="headerNavMove"></headerNavMove>
  </div>
</template>

<script>
import headerNavPc from '../components/menu/headerNavPc.vue'
import headerNavMove from '../components/menu/headerNavMove.vue'

export default {
	name: 'top-bavbar',
	components: { headerNavPc, headerNavMove },

	// props: {
	// 	Post_List: {
	// 		type: Array,
	// 		default: []
	// 	},
	// 	parent_type: {
	// 		type: String,
	// 		default: []
	// 	},
	// 	follow_button: {
	// 		type: Boolean,
	// 		default: false,
	// 	},
	// },
	data() {
		return {
			nav_name: "headerNavPc",
		}
	},
	
	// 监听
	watch: {
		// "Post_List": {
		// 	handler: function (newValue, oldValue) {
		// 		this.list = this.Post_List
		// 	},
		// 	deep: true
		// },
	},
	
	// beforeCreate() {
		
	// }
	
  created () {
	  
  },
  
  mounted() {
	  this.get_screenWidth()
	  // this.list = this.Post_List
  },
  
  methods:{
		get_screenWidth(){
			let that = this
			function screenWidth(){
				// 获取屏幕宽度
				const screenWidth = window.innerWidth;
				// 如果屏幕宽度大于800像素，则计算左边界的值
				if (screenWidth > 1024) {
					that.nav_name = "headerNavPc"
				}else{
					that.nav_name = "headerNavMove"
				}
			}
			
			screenWidth()
			window.addEventListener('resize', () => {
			   // 在这里添加你的窗口变化处理代码
			   screenWidth()
			});
		},
	//查看 粉丝或关注人信息
	check_information(item){
		console.log(item)
	},
	
	change_more(item){
		console.log(item)
	},
	
	//查看详情
	view_details(item){
		console.log(item)
	},
	
  }
}
</script>

<style lang="less" scoped>
	*{
		box-sizing: border-box;
	}
	.navbar_box {
	  width: 100%;
	  background-color: #ffffff;
	  display: flex;
	  justify-content: center;
	  position: fixed;
	  top: 0;
	  left: 0;
	  z-index: 998;
	}
	.navbar_box .navbar {
		max-width: 1280px;
		width: 100%;
		padding: 10px;
		display: flex;
		justify-content: space-between;
		list-style-type: none;
	}

	.navbar li {
		min-height: 35px;
		display: flex;
		align-items: center;
		font-size: 18px;
	}

	.navbar a {
		color: #111111;
		text-decoration: none;
	}

	.navbar a:hover {
		text-decoration: underline;
	}

	@media only screen and (max-width: 1320px) {
	  .navbar_box {
		 /* padding: 0px 10px; */
	  }
	}
	@media only screen and (min-width: 1024px) {
		
	}
	@media only screen and (max-width: 1320px) {
		/* .headerNavPc{
			display: none;
		}
		.headerNavMove{
			display: block;
		} */
	}
</style>
